import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { VisibleDirective } from './directives/visible/visible.directive';

@NgModule({
  declarations: [VisibleDirective],
  imports: [CommonModule],
  exports: [VisibleDirective],
})
export class IntersectionModule {}
